"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var polished_1 = require("polished");
var React = tslib_1.__importStar(require("react"));
var styled_components_1 = tslib_1.__importDefault(require("../../Themes/styled-components"));
var Loader_1 = tslib_1.__importDefault(require("../../Loader"));
var StyledLoader = styled_components_1.default.div(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  display: flex;\n  justify-content: center;\n  flex-direction: column;\n  padding: 0 ", ";\n"], ["\n  display: flex;\n  justify-content: center;\n  flex-direction: column;\n  padding: 0 ", ";\n"])), polished_1.rem(12));
var InputLoading = function (props) { return (React.createElement(StyledLoader, { className: props.className },
    React.createElement(Loader_1.default, null))); };
exports.default = styled_components_1.default(InputLoading)(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject([""], [""])));
var templateObject_1, templateObject_2;
